import { mapToOrderFetch } from '@atlassian/jira-project-directories-components/src/query-param-adapter/model/constants/order-field-mapper';

import type { Query } from '../../query-param-adapter/model';
import type { OrderDirection, OrderField } from '../../query-param-adapter/model/order';
import type { State } from '../reducer';

export const getQuery = (state: State): Partial<Query> => state.query;
export const getOnQueryChanged = (state: State): ((arg1: Query) => void) =>
	state.context.onQueryChanged;

export const getOrderDirection = (state: State): OrderDirection => state.query.orderDirection;
export const getOrderField = (state: State): OrderField => state.query.orderField;

export const getFilter = (state: State): string => state.query.filter;
export const getCurrentPage = (state: State): number => state.query.page;
export const getOrderBy = (state: State) =>
	mapToOrderFetch(getOrderField(state), getOrderDirection(state));
